module.exports = __webpack_public_path__ + "img/bed.878ca685.svg";